import {createContext, useContext} from 'react';

interface StripeSessionState {
  isProcessing: boolean;
  error: string | null;
  success: boolean;
  sessionId: string | null;
  clearSuccess?: () => void;
}

const StripeSessionContext = createContext<StripeSessionState | undefined>(undefined);

export const useStripeSessionContext = () => {
  const context = useContext(StripeSessionContext);
  if (context === undefined) {
    // This error suggests the context provider is missing,
    // but in some cases (like non-protected routes), this might be expected.
    // Return a default state instead of throwing an error if hook might be used optionally.
    // For now, we expect it to be present in protected contexts.
    throw new Error('useStripeSessionContext must be used within a StripeSessionProvider');
  }
  return context;
};

export const StripeSessionProvider = StripeSessionContext.Provider;
